module.exports = __webpack_public_path__ + "static/media/star.a52944be.svg";